import { render, staticRenderFns } from "./FormAssocianteDocuments.vue?vue&type=template&id=73516faf"
import script from "./FormAssocianteDocuments.vue?vue&type=script&lang=js"
export * from "./FormAssocianteDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports